/**
 * What the A.I. RFI import accepts, checked in the browser before a file is parsed or
 * uploaded (LSO-717). The server enforces the same rules; checking here first means a
 * file it would refuse is never read on the main thread, uploaded, or turned into a job
 * that fails in the background.
 */

// Mirrors the multer limit on the upload route (server/routes/rfiImport.js).
export const MAX_UPLOAD_BYTES = 30 * 1024 * 1024
// Mirrors extractSource: at most 100 pages per import, and at most 25 MB of base64
// (≈ 18.7 MB of raw PDF) after the page selection has been applied.
export const MAX_PDF_PAGES = 100
export const MAX_PDF_BYTES = Math.floor((25 * 1024 * 1024) * 3 / 4)

export const ACCEPT = '.xlsx,.xls,.csv,.docx,.pdf'
export const ACCEPTED_LABEL = 'XLSX · XLS · CSV · DOCX · PDF'
const ACCEPTED_TEXT = 'an Excel (.xlsx, .xls), CSV (.csv), Word (.docx) or PDF (.pdf) file'

const nameOf = file => (file && file.name ? file.name : '')
// CSV goes through the sheet step too: it is read as a one-sheet workbook, so the
// picker confirms it straight away.
export const isSpreadsheet = file => /\.(xlsx?|csv)$/i.test(nameOf(file))
export const isPdf = file => /\.pdf$/i.test(nameOf(file))
// Mirrors the server's detectKind (legacy binary .doc is not readable).
export const isSupported = file => /\.(xlsx?|csv|docx|pdf)$/i.test(nameOf(file))

export const formatMb = bytes => `${(bytes / (1024 * 1024)).toFixed(1)} MB`

// The reason a file can't be imported at all, or '' when it can.
export const fileProblem = (file) => {
  if (!isSupported(file)) {
    return `Unsupported file type. Please upload ${ACCEPTED_TEXT}.`
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    return `This file is ${formatMb(file.size)}; the largest file the import accepts is ${formatMb(MAX_UPLOAD_BYTES)}.`
  }
  return ''
}
